export const az = {
  title: 'Külək Sürəti Potensialı',
  subtitle: '1 km, qlobal, DTU/Dünya Bankı Qrupu/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Funksiya',
      value: 'Yer kürəsinin istənilən yeri üçün küləyin sürətini nəzərdə tutur',
    },
    {
      label: 'Qətmə',
      value: '1 km',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value: '\tDTU/Dünya Bankı Qrupu/ESMAP',
    },
    {
      label: 'Tezlik',
      value: '',
    },
    {
      label: 'Məzmun tarixi',
      value: '',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'GWA hesablamalara qeyri-müəyyənlik təqdim edə bilən iki əsas modelləşdirmə komponentindən istifadə edir. Bu komponentlər mesoskal modelləşdirmə və mikroskal modelləşdirmədir.',
    },
    {
      label: 'Lisenziya',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Qlobal Külək Atlası (GWA) o deməkdir ki, küləyin sürəti dataset Danimarka Texniki Universitetinin (DTU), Dünya Bankı Qrupu və Enerji Sektorunun İdarə Edilməsi Üzrə Yardım Proqramının (ESMAP) "Wind Energy" departamenti tərəfindən istehsal edilib.\n\nKüləyin sürəti külək enerjisinin istehsalının əsas performans göstəricilərindən biridir. GWA aşağı qətnamə külək sürəti data ilə başlayır və aşağı ölçekləmə prosesi istifadə edərək yüksək qətnamə data çevirir. Bu proses 50 metr, 100 metr və 200 metr hündürlüyündə 1 kilometr uzunluğunda olan yerli külək iqlimlərinin (Şimal və Cənub qütbləri və uzaq sahil okean əraziləri istisna olmaqla) modelidir.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
